import { c as _c } from "react/compiler-runtime";
import { ScrollDownButton } from "@/components/ScrollDownButton";
import { SocialLinks } from "@/components/SocialLinks";
import { SpinningLogo } from "@/components/SpinningLogo";
import { TaglineBox } from "@/components/TaglineBox";
import { TorusGlass } from "@/components/TorusGlass";
const heroSectionContent = {
  name: "Dimitar Daskalov",
  title: "Front End Developer",
  tagline: "Code Artist"
};
export const HeroSection = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <section aria-labelledby="hero-heading" className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden pb-24"><div className="relative z-10 flex flex-col items-center gap-4 md:gap-6 px-8 mb-16 md:mb-0"><div className="relative z-10 w-72 h-72 flex items-center justify-center"><SpinningLogo className="md:hidden" /><TorusGlass size={2} className="hidden md:block rounded-full" /></div><h1 id="hero-heading" className="heading-1 text-center text-glow">{heroSectionContent.name}</h1><strong className="body-large text-center text-(--color-accent-3)!">{heroSectionContent.title}</strong><TaglineBox tagline={heroSectionContent.tagline} /><SocialLinks ariaLabel="Social media links" buttonClassName="w-12 h-12 rounded-lg" /></div><ScrollDownButton /></section>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};